import { UnionMap, UnionValueMap } from '../../../../types/union-map';
import { MockScenarioConfiguration } from '../../../types';
import getHyperVAddOn from './get-hyper-v-add-on.json';
import createHyperVAddOn from './create-hyper-v-add-on-stub.json';

export type DataPlaneApiHyperVScenarioName = 'GetHyperVAddOn' | 'CreateHyperVAddOn';

export const DataPlaneApiHyperVScenarioName: UnionMap<DataPlaneApiHyperVScenarioName> = {
    GetHyperVAddOn: 'GetHyperVAddOn',
    CreateHyperVAddOn: 'CreateHyperVAddOn',
};

export const DataPlaneApiHyperVScenarios: UnionValueMap<DataPlaneApiHyperVScenarioName, MockScenarioConfiguration> = {
    GetHyperVAddOn: getHyperVAddOn as MockScenarioConfiguration,
    CreateHyperVAddOn: createHyperVAddOn as MockScenarioConfiguration,
};
